import { render, staticRenderFns } from "./RevendaWhatsapp.vue?vue&type=template&id=074bd123&scoped=true"
import script from "./RevendaWhatsapp.vue?vue&type=script&lang=js"
export * from "./RevendaWhatsapp.vue?vue&type=script&lang=js"
import style0 from "./RevendaWhatsapp.vue?vue&type=style&index=0&id=074bd123&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "074bd123",
  null
  
)

export default component.exports